import { render, staticRenderFns } from "./distribution2.vue?vue&type=template&id=d352d8ac&scoped=true"
import script from "./distribution2.vue?vue&type=script&lang=js"
export * from "./distribution2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d352d8ac",
  null
  
)

export default component.exports